import { render } from "./SpellingBee.vue?vue&type=template&id=592fbcc2"
import script from "./SpellingBee.vue?vue&type=script&lang=js"
export * from "./SpellingBee.vue?vue&type=script&lang=js"

import "./SpellingBee.vue?vue&type=style&index=0&id=592fbcc2&lang=css"

import exportComponent from "/home/rich/web/spelling-bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__